<template>
  <div class="project-details">
    <div v-for="project in MyProjects" :key="project.name" class="project-container">
      <div v-if="project.isVisible" class="project-content">
        <button @click="project.isVisible = !project.isVisible">
          <img src="@/assets/close.png" alt="close" />
        </button>
        <h4>
          <b>{{ project.name }}</b>
        </h4>
        <div class="myprojects">
          <div>
            <p class="description">{{ project.description }}</p>
            <p v-if="project.hasContributors" class="contrib"><u>Contributeurs</u> : {{ project.contributors }}</p>
            <div class="technos">
              <div class="tech-container">
                <img
                  v-for="tech in project.technos"
                  :key="tech"
                  v-bind:src="require('../assets/technologies/' + tech + '.png')"
                  class="tech-icon"
                />
              </div>
            </div>
          </div>
          <div class="content">
            <img :src="require('../assets/illustration-projects/' + project.illustration)" class="illustration" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projects from '../json/projects.json';

export default {
  name: 'ProjectDetails',
  data() {
    return {
      MyProjects: projects
    };
  }
};
</script>

<style lang="scss" scoped>
.project-details {
  position: fixed;
  top: 10vh;
  background-color: var(--black);
  opacity: 0.9;

  .project-container {
    color: white;

    .project-content {
      width: 100vw;
      height: 100vh;

      h4 {
        font-size: 30px;
      }

      button {
        margin-top: 30px;
        border: none;
        outline: none;
        background-color: transparent;

        img {
          width: 30px;
          cursor: pointer;
        }
      }

      .myprojects {
        .content {
          .illustration {
            display: none;
          }
        }

        p {
          margin: 0;
          padding: 0;
        }
        .contrib {
          margin-bottom: 20px;
        }
        .description {
          padding: 30px;
        }

        .technos {
          padding-bottom: 20px;

          .tech-icon {
            width: 50px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 720px) {
  .project-details {
    top: 40vh;
    .project-container {
      .project-content {
        height: 60vh !important;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .project-details {
    top: 10vh;
    opacity: 0.98;

    .project-container {
      .project-content {
        height: 100vh !important;

        .myprojects {
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;

          .description {
            width: 300px;
          }

          .content {
            .illustration {
              display: block;
              width: 500px;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
